import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { contentApiTypes } from './types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

const TOAST_ID = 'content-add-category';

export const addContentCategory = ({ pageId, name }: contentApiTypes.AddCategoryParams) => {
  return axios.post('/content/categories', {
    pageId,
    name,
  }) as Promise<contentApiTypes.AddCategoryResponse>;
};

type AddContentCategoryOptions = {
  config?: MutationConfig<typeof addContentCategory>;
};

export const useAddContentCategory = ({ config = {} }: AddContentCategoryOptions = {}) => {
  const { onSuccess, onMutate, onError, ...restConfig } = config;

  return useMutation({
    ...restConfig,
    mutationFn: addContentCategory,
    onMutate: (variables) => {
      toasts.loadingToast.loading(TOAST_ID, 'Добавление категории...');
      return onMutate?.(variables);
    },
    onSuccess: (data, variables, context) => {
      toasts.loadingToast.success(TOAST_ID, 'Категория добавлена');
      queryClient.invalidateQueries(['content-categories', variables.pageId]);
      onSuccess?.(data, variables, context);
    },
    onError: (error: AxiosError<{ error: string }>, variables, context) => {
      toasts.loadingToast.error(TOAST_ID, error.response?.data?.error);
      onError?.(error, variables, context);
    },
  });
};
